import { render, staticRenderFns } from "./SPRInput.vue?vue&type=template&id=6b58e137&scoped=true"
import script from "./SPRInput.vue?vue&type=script&lang=ts"
export * from "./SPRInput.vue?vue&type=script&lang=ts"
import style0 from "./SPRInput.vue?vue&type=style&index=0&id=6b58e137&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b58e137",
  null
  
)

export default component.exports